import ScreenRespiratorView from "./ScreenRespiratorView";

export default ScreenRespiratorView;
